import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import {
    withStyles, Typography, Modal, IconButton,
} from '@material-ui/core';

import {
    CloseIcon,
} from '../icons';

import { isIe } from '../../youwell-common/browserUtils';

const styles = theme => ({
    modalContainer: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        minWidth: '70%',
        maxWidth: '100%',
        minHeight: theme.spacing(50),
        maxHeight: '80%',
        background: theme.palette.common.white,
        display: 'flex',
        flexDirection: 'column',
        height: isIe ? '100%' : undefined,


        '&$wide': {
            minWidth: 0,
            width: `calc(80% - ${theme.spacing(4)}px)`,
        },

        [theme.breakpoints.down('xs')]: {
            minWidth: 0,
            width: `calc(100% - ${theme.spacing(4)}px)`,
        },
    },
    wide: {

    },
    modalHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(2),
        background: theme.colors.grey1,
    },
    modalHeaderText: {
        flex: '1 1 auto',
    },
    modalContent: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        padding: theme.spacing(2),
        overflowY: 'auto',
    },
});

class VimoModal extends React.Component {
    render() {
        const {
            classes, heading, children, open, onClose, wide,
        } = this.props;

        return (
            <Modal
                aria-labelledby="modal-window"
                open={open}
                onClose={onClose}
            >
                <div className={classnames(classes.modalContainer, { [classes.wide]: wide })}>
                    {heading && (
                        <div className={classes.modalHeader}>
                            <Typography variant="h6" className={classes.modalHeaderText} id="modal-window">
                                {heading}
                            </Typography>
                            <IconButton onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </div>
                    )}
                    <div className={classes.modalContent}>
                        {children}
                    </div>
                </div>
            </Modal>
        );
    }
}

VimoModal.propTypes = {
    classes: PropTypes.object.isRequired,
    children: PropTypes.node,
    heading: PropTypes.node,
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    wide: PropTypes.bool,
};

VimoModal.defaultProps = {
    children: null,
    heading: null,
    wide: false,
};

export default withStyles(styles)(VimoModal);
